// extracted by mini-css-extract-plugin
export default {"container":"IncomeStatement_container__3T6Z0","tableContainer":"IncomeStatement_tableContainer__nAtL9"};